import { call, put, takeEvery, select, fork } from "redux-saga/effects"
// Crypto Redux States
import StaffType from "./actionTypes"

import StaffAction from "./actions"
import StaffAPI from "helpers/staff_backend_helper"

function* fetchList({ payload }) {
  yield put(
    StaffAction.getListSuccess({
      loading: true,
      data: [],
    })
  )
  try {
    let { data } = yield call(StaffAPI.getList)
    yield put(
      StaffAction.getListSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    yield put(
      StaffAction.getListSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* staffSaga() {
  yield takeEvery(StaffType.GET_STAFF_LIST, fetchList)
}

export default staffSaga
